@if (hasRequestedCode()) {
<app-auth-shell title="Verifique que é você" icon="fab fa-whatsapp">
  <p class="auth-login__subtitle">Digite o código de 6 dígitos enviado pelo WhatsApp para <strong>{{ formWhatsapp.get('phone')?.value }}</strong>.</p>
  <form class="auth-login__form" role="form" [formGroup]="formWhatsapp" (ngSubmit)="verifyCode()" novalidate>
    <div class="auth-field">
      <app-auth-code-input formControlName="code" label="Código do WhatsApp" [autofocus]="true" />
      <div class="auth-login__code-meta">
        @if (validitySeconds() > 0) {
        <div class="auth-field__hint">Código válido por {{ formatCountdown(validitySeconds()) }}</div>
        } @else {
        <div class="auth-field__error">Código expirado. Solicite outro.</div>
        }
      </div>
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formWhatsapp.valid || validitySeconds() === 0">Verificar e entrar</button>
  </form>
  <div class="auth-login__actions">
    <p class="auth-login__note">
      Não recebeu o código?
      <button type="button" class="auth-link" (click)="requestCode()" [disabled]="remainingSeconds() > 0">
        @if (remainingSeconds() > 0) { Reenviar em {{ formatCountdown(remainingSeconds()) }} } @else { Reenviar código }
      </button>
    </p>
    <p class="auth-login__note">
      <button type="button" class="auth-link" (click)="changePhone()">Usar outro telefone</button>
    </p>
  </div>
  <p class="auth-login__signup" authShellFooter>
    Prefere usar a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
} @else {
<app-auth-shell title="Entrar com código no WhatsApp" subtitle="Use o telefone já vinculado à conta. O e-mail precisa estar confirmado.">
  <form class="auth-login__form" role="form" [formGroup]="formWhatsapp" (ngSubmit)="requestCode()" novalidate>
    <div class="auth-field">
      <label class="auth-field__label" for="phone">Telefone</label>
      <div class="auth-field__control">
        <input id="phone" type="tel" formControlName="phone" class="auth-field__input" placeholder="(11) 98765-4321" autocomplete="tel" appFocus />
      </div>
      @if (formWhatsapp.get('phone')?.dirty) { @if (formWhatsapp.get('phone')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formWhatsapp.get('phone')?.hasError('minLength')) {
      <div class="auth-field__error">Informe um telefone válido</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!!formWhatsapp.get('phone')?.invalid || remainingSeconds() > 0">
      @if (remainingSeconds() > 0) { Reenviar em {{ formatCountdown(remainingSeconds()) }} } @else { Enviar código }
    </button>
  </form>
  <p class="auth-login__signup" authShellFooter>
    Prefere usar a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
}
